import { KeyboardReturn } from "@mui/icons-material";
import { Export } from "./baseApiClient";

const createExportObject = (exportType, documentType)=>{

    if(documentType == "invoice") {
        return {
            exportType: exportType,
            template: "default",
            templateClass:"FVExpressBackend.Infrastructure.Exporters.DTO.InvoiceV1TemplateModel",
            documentClass:"FVExpressBackend.Application.Invoicing.DTO.InvoiceV1DTO",
            entityClass:"FVExpressBackend.Domain.Invoicing.Entities.V1.InvoiceV1",
            documentType: documentType,
            document: null
        }
    }

    if(documentType == "invoiceDuplicate") {
        return {
            exportType: exportType,
            template: "invoiceDuplicate",
            templateClass:"FVExpressBackend.Infrastructure.Exporters.DTO.InvoiceDuplicateV1TemplateModel",
            documentClass:"FVExpressBackend.Application.Invoicing.DTO.InvoiceV1DTO",
            entityClass:"FVExpressBackend.Domain.Invoicing.Entities.V1.InvoiceV1",
            documentType: documentType,
            document: null
        }
    }

    if(documentType == "proforma") {
        return {
            exportType: exportType,
            template: "proforma",
            templateClass:"FVExpressBackend.Infrastructure.Exporters.DTO.ProformaInvoiceV1TemplateModel",
            documentClass:"FVExpressBackend.Application.ProformaInvoicing.DTO.ProformaInvoiceV1DTO",
            entityClass:"FVExpressBackend.Domain.ProformaInvoicing.Entities.V1.ProformaInvoiceV1",
            documentType: documentType,
            document: null
        }
    }

    if(documentType == "proformaDuplicate") {
        return {
            exportType: exportType,
            template: "proformaDuplicate",
            templateClass:"FVExpressBackend.Infrastructure.Exporters.DTO.ProformaInvoiceDuplicateV1TemplateModel",
            documentClass:"FVExpressBackend.Application.ProformaInvoicing.DTO.ProformaInvoiceV1DTO",
            entityClass:"FVExpressBackend.Domain.ProformaInvoicing.Entities.V1.ProformaInvoiceV1",
            documentType: documentType,
            document: null
        }
    }

    if(documentType == "correctionInvoice") {
        return {
            exportType: exportType,
            template: "correction",
            templateClass:"FVExpressBackend.Infrastructure.Exporters.DTO.CorrectionInvoiceV1TemplateModel",
            documentClass:"FVExpressBackend.Application.CorrectionInvoicing.DTO.CorrectionInvoiceV1DTO",
            entityClass:"FVExpressBackend.Domain.ProvisionalInvoicing.Entities.V1.CorrectionInvoiceV1",
            documentType: documentType,
            document: null
        }
    }

    if(documentType == "correctionInvoiceDuplicate") {
        return {
            exportType: exportType,
            template: "correctionDuplicate",
            templateClass:"FVExpressBackend.Infrastructure.Exporters.DTO.CorrectionInvoiceDuplicateV1TemplateModel",
            documentClass:"FVExpressBackend.Application.CorrectionInvoicing.DTO.CorrectionInvoiceV1DTO",
            entityClass:"FVExpressBackend.Domain.ProvisionalInvoicing.Entities.V1.CorrectionInvoiceV1",
            documentType: documentType,
            document: null
        }
    }

}

export const createPdfExportObject = (documentType)=>{
    return createExportObject("pdf", documentType);
}

export const createEmailExportObject = (documentType)=>{
    return createExportObject("email", documentType);
}

export const downloadPdf = async (exportObj) =>{
    var blob = await Export(exportObj); 
    saveFile(blob);
}

export const queueEmail = async (exportObj) =>{
   await Export(exportObj);    
}

const saveFile = (file) =>{
    const a = document.createElement('a');
    a.href = URL.createObjectURL(file);
    a.download = "faktura_vat.pdf";           
    a.click();      
}
